import { Col } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { isFinite } from 'lodash/fp';
import React from 'react';
import { type FinderVehicleSpecsFragment } from '../../../api/fragments/FinderVehicleSpecs';

export type FinderVehicleFormValues = FinderVehicleSpecsFragment;

export type FinderVehicleFieldSectionProps = {
    labelPrefix: string;
    formPrefix: string;
};

export const colSpan = { lg: 8, md: 12, xs: 24 };

type VehicleColumnProps = { children: JSX.Element | React.ReactNode };

export const VehicleColumn = ({ children }: VehicleColumnProps) => <Col {...colSpan}>{children}</Col>;

export const getDepreciation = (
    price: number,
    parfRebateAmount: number,
    coeExpiryDate: Date | string,
    registrationDate: Date | string,
    today: Dayjs
) => {
    if (isFinite(price) && isFinite(parfRebateAmount) && coeExpiryDate && registrationDate) {
        const diff = dayjs(coeExpiryDate).diff(today, 'year', true);

        if (today.diff(dayjs(registrationDate), 'year', true) <= 10) {
            if (diff > 0) {
                const amount = (price - parfRebateAmount) / (diff < 1 ? 1 : diff);

                return amount > 0 ? amount : undefined;
            }

            return price - parfRebateAmount;
        }

        if (diff > 0) {
            const amount = price / (diff < 1 ? 1 : diff);

            return amount > 0 ? amount : undefined;
        }

        return price;
    }

    return undefined;
};
